const popoverStyles = (tokens) => ({
    baseStyle: {
        content: {
            padding: tokens.Spacing04,
            boxShadow: '0 2px 4px 0px rgba(26, 26, 26, 0.20)',
        },
        header: {
            borderBottom: 'none',
        },
        footer: {
            borderTop: 'none',
        },
        closeButton: {
            position: 'absolute',
            top: '24px',
            right: '18px',
            width: '24px',
            height: '24px',
            fontSize: '14px',
        },
    },
});
export default popoverStyles;
